<div
  class="z-[999] fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4"
>
  <div
    class="modal-enter w-full max-w-[1040px] h-[88vh] bg-white rounded-2xl shadow-2xl ring-1 ring-black/5 overflow-hidden flex flex-col"
    role="dialog"
    aria-modal="true"
    aria-labelledby="add-widgets-title"
  >
    <!-- HEADER -->
    <div class="flex-none flex items-start justify-between gap-4 px-6 pt-5 pb-3">
      <div class="min-w-0 flex flex-col gap-1">
        <h1
          id="add-widgets-title"
          class="text-dimot-1 text-[0.84rem] xl:text-[1.03rem] 2xl:text-[1rem] text-start"
        >
          Aggiungi Widget alla tua Dashboard
        </h1>
        <p class="text-[0.55rem] xl:text-[0.62rem] 2xl:text-[0.7rem] 3xl:text-[0.85rem] leading-relaxed text-gray-500 text-start">
          Scegli i widget da aggiungere e personalizza la tua dashboard nazionale.
        </p>
      </div>

      <button
        type="button"
        (click)="closeModal()"
        aria-label="Chiudi"
        class="shrink-0 -mr-2 -mt-1 grid place-items-center rounded-full p-2 cursor-pointer
               focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dimot-1/40"
      >
        <svg
          class="w-4 h-4 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#141F58"
          />
        </svg>
      </button>
    </div>

    <!-- TOOLBAR -->
    <div
      *ngIf="widgets.length > 0"
      class="flex-none flex flex-col sm:flex-row sm:items-center gap-3 px-6 pb-4 border-b border-gray-100"
    >
      <div class="relative flex-1 min-w-0">
        <svg
          class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none"
          viewBox="0 0 24 24" fill="none" aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2" />
          <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        <input
          type="text"
          [value]="searchTerm"
          (input)="onSearch($event)"
          placeholder="Cerca widget..."
          aria-label="Cerca widget"
          class="w-full h-8 2xl:h-9 pl-9 pr-8 rounded-lg border border-gray-200 bg-tableHead
                 text-[0.65rem] 2xl:text-[0.75rem] text-dimot-1 placeholder:text-gray-400
                 focus:outline-none focus:border-dimot-1/40 focus:ring-2 focus:ring-dimot-1/10 transition"
        />
        <button
          *ngIf="searchTerm"
          type="button"
          (click)="clearSearch()"
          aria-label="Cancella ricerca"
          class="absolute right-2 top-1/2 -translate-y-1/2 p-1 cursor-pointer text-gray-400 hover:text-dimot-1"
        >
          <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 18L18 6M18 18L6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="flex-none inline-flex p-0.5 rounded-lg bg-tableHead2 text-[0.6rem] 2xl:text-[0.7rem] font-medium" role="tablist">
        <button
          *ngFor="let tab of filterTabs"
          type="button"
          role="tab"
          class="px-3 h-7 2xl:h-8 rounded-md cursor-pointer transition"
          [ngClass]="getFilterTabClasses(tab.value)"
          [attr.aria-selected]="activeFilter === tab.value"
          (click)="setFilter(tab.value)"
        >
          {{ tab.label }} <span class="opacity-60">{{ getFilterCount(tab.value) }}</span>
        </button>
      </div>
    </div>

    <div class="flex-1 min-h-0 flex flex-col overflow-y-auto scrollbar px-6 py-5 bg-[#FBFCFD]">
      <!-- GRID -->
      <div *ngIf="filteredWidgets.length > 0" #widgetsGrid class="widgets-grid">
        <button
          *ngFor="let widget of displayedWidgets; let i = index; trackBy: trackById"
          type="button"
          class="widget-card group relative flex flex-col text-left rounded-xl bg-white border-2 overflow-hidden transition-all duration-200"
          [class.widget-card--wide]="isWide(widget)"
          [style.animation-delay.ms]="i * 25"
          [attr.aria-disabled]="widget.visible"
          [attr.aria-pressed]="isSelected(widget)"
          [ngClass]="getCardClasses(widget)"
          (click)="toggleWidget(widget)"
        >
          <div
            class="relative flex-none h-[150px] 2xl:h-[170px] bg-tableHead border-b border-gray-100 overflow-hidden"
          >
            <div
              class="widget-preview absolute inset-3 transition-transform duration-300"
              [ngClass]="getPreviewClasses(widget)"
            ></div>

            <span
              *ngIf="widget.visible"
              class="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-white/90 ring-1 ring-black/5
                     text-[0.55rem] 2xl:text-[0.62rem] font-medium text-dimot-1"
            >
              <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              In uso
            </span>

            <span
              *ngIf="!widget.visible"
              class="absolute top-2 right-2 w-5 h-5 rounded-full border-2 grid place-items-center transition-all"
              [ngClass]="getCheckClasses(widget)"
            >
              <svg
                *ngIf="isSelected(widget)"
                class="w-3 h-3 text-white"
                viewBox="0 0 24 24" fill="none" aria-hidden="true"
              >
                <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </div>

          <div class="flex-1 flex flex-col gap-1 px-3 py-2.5">
            <h3
              class="font-semibold text-dimot-1 text-[0.62rem] 2xl:text-[0.72rem] leading-snug line-clamp-2"
            >
              {{ widget.name }}
            </h3>
            <p
              class="text-gray-500 text-[0.55rem] 2xl:text-[0.63rem] leading-relaxed line-clamp-2"
            >
              {{ getTooltipText(widget.id) }}
            </p>
          </div>

          <!-- hover panel -->
          <div
            [ngClass]="getHoverPanelHeight(widget)"
            class="absolute inset-x-0 bottom-0 z-10 flex flex-col gap-1 px-3 py-2.5 bg-white border-t border-gray-100
                   shadow-[0_-6px_16px_-8px_rgba(20,30,88,0.25)] pointer-events-none
                   opacity-0 translate-y-2 transition-all duration-200
                   group-hover:opacity-100 group-hover:translate-y-0
                   group-focus-visible:opacity-100 group-focus-visible:translate-y-0"
            aria-hidden="true"
          >
            <h3 class="font-semibold text-dimot-1 text-[0.62rem] 2xl:text-[0.72rem] leading-snug">
              {{ widget.name }}
            </h3>
            <p class="text-gray-500 text-[0.55rem] 2xl:text-[0.63rem] leading-relaxed">
              {{ getTooltipText(widget.id) }}
            </p>
          </div>
        </button>
      </div>

      <!-- no widgets for the company -->
      <div
        *ngIf="widgets.length === 0"
        class="flex-1 flex flex-col items-center justify-center text-center gap-2 py-14"
      >
        <div class="w-12 h-12 rounded-full bg-tableHead2 grid place-items-center mb-1">
          <svg class="w-6 h-6 text-dimot-1" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.5" />
            <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.5" />
            <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.5" />
            <path d="M17.5 14v7M14 17.5h7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </div>
        <h4 class="text-dimot-1 font-semibold text-[0.75rem] 2xl:text-[0.85rem]">Nessun widget disponibile</h4>
        <p class="text-gray-500 text-[0.6rem] 2xl:text-[0.7rem] max-w-[320px]">
          Al momento non ci sono widget abilitati per la tua azienda.
        </p>
      </div>

      <!-- no results -->
      <div
        *ngIf="widgets.length > 0 && filteredWidgets.length === 0"
        class="flex-1 flex flex-col items-center justify-center text-center gap-2 py-14"
      >
        <h4 class="text-dimot-1 font-semibold text-[0.75rem] 2xl:text-[0.85rem]">
          {{ emptyStateTitle }}
        </h4>
        <p class="text-gray-500 text-[0.6rem] 2xl:text-[0.7rem] max-w-[320px]">
          {{ emptyStateMessage }}
        </p>
        <button
          *ngIf="searchTerm"
          type="button"
          (click)="clearSearch()"
          class="mt-1 text-[0.6rem] 2xl:text-[0.7rem] font-medium text-[#0A778A] hover:underline cursor-pointer"
        >
          Cancella ricerca
        </button>
      </div>
    </div>

    <!-- FOOTER -->
    <div
      class="flex-none flex flex-col sm:flex-row items-center justify-between gap-3 px-6 py-4 border-t border-gray-100 bg-white"
    >
      <div class="flex items-center gap-3 text-[0.62rem] 2xl:text-[0.75rem] text-dimot-1">
        <span>
          Hai selezionato <span class="font-bold">{{ newlySelectedCount }}</span> widget
        </span>
        <button
          *ngIf="availableCount > 0"
          type="button"
          (click)="toggleSelectAllAvailable()"
          class="font-medium text-[#0A778A] hover:underline cursor-pointer"
        >
          {{ allAvailableSelected ? 'Deseleziona tutti' : 'Seleziona tutti' }}
        </button>
      </div>

      <div class="flex items-center gap-2">
        <button
          type="button"
          (click)="closeModal()"
          class="h-8 2xl:h-9 px-4 rounded-lg border border-gray-200 bg-white text-gray-600
                 text-[0.62rem] 2xl:text-[0.72rem] font-medium cursor-pointer hover:bg-gray-50 transition"
        >
          Annulla
        </button>
        <button
          type="button"
          (click)="addWidgetsToDashboard()"
          [disabled]="newlySelectedCount === 0"
          class="h-8 2xl:h-9 px-4 rounded-lg bg-dimot-1 text-white inline-flex items-center gap-2
                 text-[0.62rem] 2xl:text-[0.72rem] font-medium cursor-pointer transition
                 hover:bg-dimot-1/90 active:scale-[0.98]
                 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100"
        >
          <svg class="w-3.5 h-3.5" viewBox="0 0 20 19" fill="none" aria-hidden="true">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.0213 16.5211C11.9643 16.5211 13.8277 15.7493 15.2016 14.3754C16.5755 13.0015 17.3473 11.1381 17.3473 9.19514C17.3473 7.25216 16.5755 5.38877 15.2016 4.01488C13.8277 2.64098 11.9643 1.86914 10.0213 1.86914C8.07834 1.86914 6.21494 2.64098 4.84105 4.01488C3.46716 5.38877 2.69531 7.25216 2.69531 9.19514C2.69531 11.1381 3.46716 13.0015 4.84105 14.3754C6.21494 15.7493 8.07834 16.5211 10.0213 16.5211ZM10.9371 6.44789C10.9371 6.20502 10.8406 5.97209 10.6688 5.80036C10.4971 5.62862 10.2642 5.53214 10.0213 5.53214C9.77844 5.53214 9.54552 5.62862 9.37378 5.80036C9.20204 5.97209 9.10556 6.20502 9.10556 6.44789V8.27939H7.27406C7.03119 8.27939 6.79827 8.37587 6.62653 8.54761C6.45479 8.71934 6.35831 8.95227 6.35831 9.19514C6.35831 9.43801 6.45479 9.67094 6.62653 9.84267C6.79827 10.0144 7.03119 10.1109 7.27406 10.1109H9.10556V11.9424C9.10556 12.1853 9.20204 12.4182 9.37378 12.5899C9.54552 12.7617 9.77844 12.8581 10.0213 12.8581C10.2642 12.8581 10.4971 12.7617 10.6688 12.5899C10.8406 12.4182 10.9371 12.1853 10.9371 11.9424V10.1109H12.7686C13.0114 10.1109 13.2444 10.0144 13.4161 9.84267C13.5878 9.67094 13.6843 9.43801 13.6843 9.19514C13.6843 8.95227 13.5878 8.71934 13.4161 8.54761C13.2444 8.37587 13.0114 8.27939 12.7686 8.27939H10.9371V6.44789Z"
              fill="currentColor"
            />
          </svg>
          Aggiungi alla Dashboard
          <span
            *ngIf="newlySelectedCount > 0"
            class="min-w-[18px] h-[18px] px-1 rounded-full bg-white text-dimot-1 text-[0.55rem] font-bold grid place-items-center"
          >
            {{ newlySelectedCount }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
